/**
 * Created by Rodrigo Quesada on 03/05/17.
 */
import {Model, ModelMixin} from '../../../domain/model/common/model.class';
import {User} from '../../../domain/model/user/user.model';
import {Profile} from '../../../domain/model/profile/profile.model';
import ProjectionInformation = Model.ProjectionInformation;

export class BasicInfo extends ModelMixin() implements Model<BasicInfo> {

    TYPE = BasicInfo;
    static projectionInformation = new ProjectionInformation('basicInfo');

    user: User = new User();
    profile: Pick<Profile, 'practiceSpecialties' | 'languages'> = new Profile();

    constructor(jsonData: any = {}) {
        super();
        this.user = new User(jsonData.user);
        this.profile = new Profile(jsonData.profile);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/personal-details/model/basic-info.model.ts